import React, { FC }                 from 'react';
import { ENVIRONMENT_IS_PRODUCTION } from '@src/constants';

//@ts-ignore
let environment = __ENV__;

// @note: AUTO GENERATED at run / build time!
const gitBranchManifest = require( '../../../_manifests/git-branch.json' );

interface Props {
    useHash?: boolean,
}

const defaultProps: Props = {
    useHash: false,
}

const CorvalBranchName: FC<Props> = ( props ) => {

    let isProduction          = ENVIRONMENT_IS_PRODUCTION,
        branchDelimiterString = '%BRANCH%',
        branchURL             = environment.branchURL.replace( branchDelimiterString, gitBranchManifest.branch );

    const handleOnClick = () => {

        window.open( branchURL, '_blank' );
    }

    const containerProps = isProduction ? {} : {
        onClick:   handleOnClick,
        className: 'cursor--pointer opacity-hover--80'
    }

    return (
        <span { ...containerProps }>{ props.useHash ? gitBranchManifest.hash : gitBranchManifest.branch }</span>
    );
};

CorvalBranchName.defaultProps = defaultProps;

export { CorvalBranchName }
